function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
export var RETRIEVE_USAGE_CAPS = {
  BEGIN: 'RETRIEVE_USAGE_CAPS_SETTINGS.BEGIN',
  SUCCESS: 'RETRIEVE_USAGE_CAPS_SETTINGS.SUCCESS',
  FAILURE: 'RETRIEVE_USAGE_CAPS_SETTINGS.FAILURE'
};
var RETRIEVE_USAGE_CAPS_CONSTANTS = [RETRIEVE_USAGE_CAPS.BEGIN, RETRIEVE_USAGE_CAPS.SUCCESS, RETRIEVE_USAGE_CAPS.FAILURE];
export var retrieveUsageCapsPromise = function retrieveUsageCapsPromise(dispatch, customerId) {
  var serviceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return ThunkHelper(dispatch, RETRIEVE_USAGE_CAPS_CONSTANTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveUsageCapElections',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ServiceIdentifier: serviceId
    }
  });
};
export var retrieveUsageCaps = function retrieveUsageCaps(customerId, serviceId) {
  return function (dispatch) {
    return retrieveUsageCapsPromise(dispatch, customerId, serviceId);
  };
};
export var UPDATE_USAGE_CAP_ELECTIONS = {
  BEGIN: 'UPDATE_USAGE_CAP_ELECTIONS.BEGIN',
  FAILURE: 'UPDATE_USAGE_CAP_ELECTIONS.FAILURE',
  SUCCESS: 'UPDATE_USAGE_CAP_ELECTIONS.SUCCESS'
};
var UPDATE_USAGE_CAP_ELECTIONS_CONSTANTS = [UPDATE_USAGE_CAP_ELECTIONS.BEGIN, UPDATE_USAGE_CAP_ELECTIONS.SUCCESS, UPDATE_USAGE_CAP_ELECTIONS.FAILURE];
export var updateUsageCapsElections = function updateUsageCapsElections(customerId, usageCapElections) {
  return function (dispatch) {
    return ThunkHelper(dispatch, UPDATE_USAGE_CAP_ELECTIONS_CONSTANTS, {
      method: 'post',
      url: 'SubscriberManagement/UpdateUsageCapElections',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: usageCapElections
    });
  };
};
export var UPDATE_USAGE_CAPS_DETAILS = 'UPDATE_USAGE_CAPS_DETAILS';
export var updateUsageCapsDetails = function updateUsageCapsDetails(payload) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USAGE_CAPS_DETAILS,
      payload: payload
    });
    return Promise.resolve();
  };
};